import { pad2 } from "../omnia"
import { Layer } from "./types"

export interface Filters {
    setId?: number
    date: DateFilter
}

export interface DateFilter {
    // Expressed as 6 digits numbers, yyyymm
    // yyyy00 represents a whole year
    date: number
    comparison: "in" | "before" | "since"
}

export function getDateFilterOptions(layers: Layer[]): [number, string][] {

    const options: [number, string][] = layers
        .filter(l => !l.dynamicScale)
        .flatMap(l => {
            const d = new Date(l.date ?? l.importDate)
            const y = d.getFullYear() * 100
            return [
                y,
                y + (d.getMonth() + 1)
            ]
        })
        .unique(d => d)
        .sort((a, b) => b - a)
        .map(a => {
            const { year, month } = parseDateFilter(a)
            return [
                a,
                month === 0 ? String(year) : `${pad2(month)}/${year}`
            ]

        })

    return options


}

export function applyDateFilter(layers: Layer[], { date, comparison }: Filters["date"]) {

    if (!(date && comparison)) {
        return layers
    }

    const { year, month } = parseDateFilter(date)

    const comparisons: { [cmp in DateFilter["comparison"]]: (y: number, m: number) => boolean } = {
        "since": (y, m) => (y > year) || ((y === year) && (m >= month)),
        "before": (y, m) => (y < year) || ((y === year) && (m < month)),
        "in": (y, m) => (y === year) && ((month === 0) || (m === month))
    }

    const cmpf = comparisons[comparison]

    return layers.filter(l => {
        const d = new Date(l.date ?? l.importDate)
        return cmpf(d.getFullYear(), d.getMonth() + 1)
    })

}

function parseDateFilter(date: number) {

    const month = date % 100
    const year = Math.floor(date / 100)

    return {
        year,
        month
    }

}
